import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import CheckIcon from '../assets/icons/CheckIconBlack.svg';
import { Card, CardContent } from './ui/card';
import './DriveWithUsSection.css';

const DriveWithUsSection = () => {
  const [expandedSection, setExpandedSection] = useState('benefits');

  const benefits = [
    {
      title: 'Earn on Your Terms',
      description: 'Drive when you want, where you want. No minimum hours required.'
    },
    {
      title: 'Competitive Rates',
      description: 'Keep 75-78% of every fare. Higher rates for Women-for-Women programs. Weekly payouts via direct deposit.'
    },
    {
      title: 'Fair Treatment',
      description: 'Transparent pricing with no hidden fees. Support from real people, not just algorithms. Driver advisory board gives you a voice.'
    },
    {
      title: 'Community Impact',
      description: 'Make a difference in your community. Build meaningful connections with regular riders. Support local families and strengthen neighborhood networks.'
    },
    {
      title: 'Professional Development',
      description: 'Free training and certification programs. Community college partnership for career credits. Pathways to transportation career advancement.'
    },
    {
      title: 'Electric Vehicle Incentives',
      description: 'Reduced commission rates for EV and hybrid drivers (80-82% retention). Priority ride assignments for eco-friendly vehicles.'
    }
  ];

  const requirements = [
    'Valid Class G driver\'s license',
    'Clean driving record',
    'Commercial auto insurance',
    'Minimum 3 years driving experience',
    'Vehicle less than 8 years old',
    'Pass comprehensive background check'
  ];

  const process = [
    {
      title: 'Online Application (10 minutes)',
      description: "Complete our simple online form with personal information, driver's license details, and vehicle information."
    },
    {
      title: 'Document Verification (2-3 days)',
      description: "Upload driver's license, vehicle registration, insurance proof, and vehicle photos. Our team reviews and verifies all documents."
    },
    {
      title: 'Background Check (5-7 days)',
      description: 'Criminal record check and driving record review. Reference verification.'
    },
    {
      title: 'Training & Onboarding (4 hours)',
      description: 'Complete online and in-person training modules. Learn platform features, safety protocols, and customer service excellence.'
    },
    {
      title: 'Vehicle Inspection (1 hour)',
      description: 'Bring your vehicle to an approved inspection facility for comprehensive safety check.'
    },
    {
      title: 'Start Driving',
      description: 'Receive your Zoplop driver kit. Download the driver app. Go online and start accepting rides.'
    }
  ];

  const features = [
    'Real-time ride requests',
    'Upfront fare information',
    'Efficient routing with traffic updates',
    'Flexible schedule go online whenever you want',
    '24/7 driver support',
    'Transparent earnings breakdown',
    'Weekly direct deposit payments',
    'Navigation integration',
    'Performance tracking'
  ];

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  return (
    <section id="drive" className="drive-with-us-section">
      <div className="section-container">
        <div>
          <h2 className="section-title">Drive with Zoplop</h2>
        </div>
        
        <div className="expandable-section">
          <button
            className="section-toggle"
            onClick={() => toggleSection('benefits')}
          >
            <span className="toggle-title">Why Drive With Us?</span>
            {expandedSection === 'benefits' ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
          </button>
          {expandedSection === 'benefits' && (
            <div className="section-content">
              <div className="benefits-grid">
                {benefits.map((benefit, index) => (
                  <Card key={index} className="benefit-card">
                    <CardContent className="benefit-content">
                      <h3 className="benefit-title">{benefit.title}</h3>
                      <p className="benefit-description">{benefit.description}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="expandable-section">
          <button
            className="section-toggle"
            onClick={() => toggleSection('requirements')}
          >
            <span className="toggle-title">Driver Requirements</span>
            {expandedSection === 'requirements' ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
          </button>
          {expandedSection === 'requirements' && (
            <div className="section-content">
              <ul className="requirements-list">
                {requirements.map((req, index) => (
                  <li key={index} className="requirement-item">
                    <img src={CheckIcon} alt="check" className="check-icon" />
                    <span>{req}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="expandable-section">
          <button
            className="section-toggle"
            onClick={() => toggleSection('application')}
          >
            <span className="toggle-title">Application Process</span>
            {expandedSection === 'application' ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
          </button>
          {expandedSection === 'application' && (
            <div className="section-content">
              <div className="benefits-grid">
                {process.map((process, index) => (
                  <Card key={index} className="benefit-card">
                    <CardContent className="benefit-content">
                      <h3 className="benefit-title">{process.title}</h3>
                      <p className="benefit-description">{process.description}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="expandable-section">
          <button
            className="section-toggle"
            onClick={() => toggleSection('features')}
          >
            <span className="toggle-title">Driver App Features</span>
            {expandedSection === 'features' ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
          </button>
          {expandedSection === 'features' && (
            <div className="section-content">
              <ul className="requirements-list">
                {features.map((req, index) => (
                  <li key={index} className="requirement-item">
                    <img src={CheckIcon} alt="check" className="check-icon" />
                    <span>{req}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default DriveWithUsSection;